import Tooltip from "@mui/material/Tooltip";
import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";

interface ChatbotLauncherProps {
	onClick: () => void;
}

export const ChatbotLauncher = ({ onClick }: ChatbotLauncherProps) => {
	const { t } = useTranslation();

	return (
		// MUI Tooltip wprost — wrapper div z LekUI/Tooltip nie ma wymiarów przy position: fixed.
		<Tooltip title={t("globalChatbot.title", "Tutor AI")} placement="left">
			<button
				type="button"
				data-test-id="global-chatbot-launcher"
				className="chatbot-fab"
				onClick={onClick}
				aria-label={t("globalChatbot.open", "Otwórz Tutor AI")}
			>
				<Sparkles className="icon-normal" />
			</button>
		</Tooltip>
	);
};
